import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import {OwlMomentDateTimeModule} from 'ng-pick-datetime-moment';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import {FilesComponent} from './components/files/files.component';
import {LastFilesComponent} from './components/last-files/last-files.component';
import {FilesService} from './components/files/files.service';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';
import { FilesTableDataComponent } from './components/files-table-data/files-table-data.component';
import {FilesDownloadComponent} from './components/files-download/files-download.component';
import {FilesCountDownloadComponent} from './components/files-count-download/files-count-download.component';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        BsDatepickerModule.forRoot(),
        NgxDatatableModule,
        NguiAutoCompleteModule,
        OwlDateTimeModule,
        OwlMomentDateTimeModule
    ],
    exports: [
        LastFilesComponent
    ],
    providers: [
        FilesService,
    ],
    declarations: [FilesComponent, LastFilesComponent, FilesTableDataComponent, FilesDownloadComponent, FilesCountDownloadComponent]
})

export class FileModule {
}





// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/files/file.module.ts